import getDriver from "./getDriver";
import createDriver from "./createDriver";
import updateDriver from "./updateDriver";
import deleteDriver from "./deleteDriver";

export { getDriver, createDriver, updateDriver, deleteDriver };

export default { getDriver, createDriver, updateDriver, deleteDriver };
